import Page from './views/Page.vue';

const routes = [
  {
    path: '/p/:url',
    name: 'page',
    component: Page,
  },
];

export default routes;
